import { getSiteDataUsage as publicGetSiteDataUsage } from './cloud-data-usage-v1-site-data-usage-data.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const getSiteDataUsage: MaybeContext<
  BuildRESTFunction<typeof publicGetSiteDataUsage> &
    typeof publicGetSiteDataUsage
> = /*#__PURE__*/ createRESTModule(publicGetSiteDataUsage);

export {
  CollectionType,
  Segment,
  Type,
  DataStore,
  Action,
  WebhookIdentityType,
} from './cloud-data-usage-v1-site-data-usage-data.universal.js';
export {
  SiteDataUsage,
  Usage,
  DataCollectionUsage,
  GetSiteDataUsageRequest,
  GetSiteDataUsageResponse,
  BulkUpdateUsagesRequest,
  DataCollectionUsageUpdate,
  InstanceUsageUpdate,
  BulkUpdateUsagesResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  DataChangeEvent,
  DataChangeEventEventOneOf,
  DataChanged,
  DataChangedChangeOneOf,
  Initiator,
  Identity,
  Enrichment,
  ChangesLost,
  ReferenceChanged,
  SegmentChanged,
  SegmentMigrationStarted,
  IgnoredSourceEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetSiteDataUsageOptions,
} from './cloud-data-usage-v1-site-data-usage-data.universal.js';
export {
  CollectionTypeWithLiterals,
  SegmentWithLiterals,
  TypeWithLiterals,
  DataStoreWithLiterals,
  ActionWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './cloud-data-usage-v1-site-data-usage-data.universal.js';
